/* ### CONSTANTS ### */

import { IQueryMetaDataType } from '../../../../../boilerplate/redux/types/IQueryMetaDataType';
import { IApiErrorType } from '../../../../types/BaseTypes';

export const TAG_FETCH_ENTRIES = '@BasePipeline/tagReducer_FETCH_ENTRIES';
export const TAG_FETCH_ENTRY   = '@BasePipeline/tagReducer_FETCH_ENTRY';
export const TAG_ADD_ENTRIES = '@BasePipeline/tagReducer_ADD_ENTRIES';
export const TAG_ADD_ENTRY = '@BasePipeline/tagReducer_ADD_ENTRY';

export const TAG_SET_ERRORS   = '@BasePipeline/tagReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function fetchTags (queryKey: string) {
	return {
		type: TAG_FETCH_ENTRIES,
		queryKey,
	};
}

export function addTagEntries (queryKey: string, entries: ITagType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function addTagEntry (queryKey: string, entry: ITagType, metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_ADD_ENTRY,
		queryKey,
		entry,
		metaData,
		options
	};
}

export function setTagErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: TAG_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
